import { NewPageList } from "./new-page-list";

export class Organizer {
    $key: string;

    name: string;
    website: string = null;
    type: string = null;
    position: number;

    hasDetailsPage: boolean = false;

    bannerName: string = null;
    bannerUrl: string = null;
    bannerCMId: string = null;

    organization: string;
    designation: string;
    email: string;
    phoneNo: string;

    isEmailVisible: boolean = false;
    isPhoneNoVisible: boolean = false;

    aboutList = new Array<NewPageList>();
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/organizer.ts